module.exports = __webpack_public_path__ + "static/ogp-not-found-4cdfe2495e41b8786d2669914867e07b.png";